/**
 * Created by tomers on 5/7/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/agent-groups/agentGroupEdit.tmpl");
    var UsersCollection = require("collections/entities/UsersCollection");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var Multiselect = require("ui/multiselect/Multiselect");
    var Paging = require("ui/paging/Paging");
    var Bubble = require("ui/bubble/Bubble");

    var AgentGroupEditView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupEditView = Marionette.Layout.extend({
            className: "agent-group-edit",
            template: template,
            regions: {
                gridRegion: ".agent-group-table"
            },
            ui:{
                agentGroupName: ".agent-group-name-input",
                agentGroupDescription: ".agent-group-description",
                managers: ".agent-group-managers-container .agent-group-managers-input",
                members: ".agent-group-members-container .agent-group-members-input",
                pendingAssignment: ".agent-group-members-container .pending-assignment-container",
                pendingAssignmentInfo: ".agent-group-members-container .pending-assignment-info",
                cancelButton: ".cancel-button",
                saveButton: ".save-button",
                pagingContainer: ".agent-group-list-paging-container"
            },
            uiComponents: {
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view.membersTableCollection",
                        blockWrongPageNumber: true
                    },
                    events: {
                        "change:page": "_onPagingChange"
                    }
                },
                agentGroupName: {
                    type: InputField,
                    options: {
                        el: "view.ui.agentGroupName",
                        permutation: InputField.Permutation.B,
                        placeholder: LE.translator.translate("LEUserManagement.agentGroupEdit.groupNname.placeholder"),
                        maxLength: "view.modelValidators.maxNameLength",
                        value: "view.model.getName"
                    },
                    events: {
                        change: "_onNameChange"
                    }
                },
                agentGroupDescription: {
                    type: InlineTextarea,
                    options: {
                        permutation: InlineTextarea.PERMUTATION.A,
                        container: "view.ui.agentGroupDescription",
                        value: "view.model.getDescription"
                    },
                    events: {
                        change: "_onDescriptionChange"
                    }
                },
                managers: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.managers",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        asyncFilter: true,
                        asyncFilterMinChars: 2,
                        trim: false,
                        list: {
                            noItems: {
                                visible: true,
                                value: LE.translator.translate("LEUserManagement.agentGroupEdit.manager.noItems.placeholder")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.agentGroupEdit.manager.placeholder"),
                            inlineErrorText: LE.translator.translate("LEUserManagement.agentGroupEdit.errors.manager.select"),
                            tagMaxWidth: "275px",
                            maxShownLines: 2,
                            tooltipAlign: "left"
                        },
                        items: "view._getSelectedManagersItems"
                    },
                    events: {
                        select: "_onManagerSelect",
                        unselect: "_onManagerUnselect",
                        filter: "_onManagerFilter"
                    }
                },
                members: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.members",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        asyncFilter: true,
                        asyncFilterMinChars: 2,
                        trim: false,
                        list: {
                            noItems: {
                                visible: true,
                                value: LE.translator.translate("LEUserManagement.agentGroupEdit.member.noItems.placeholder")
                            }
                        },
                        tagsContainer: {
                            placeholder: LE.translator.translate("LEUserManagement.agentGroupEdit.member.placeholder"),
                            inlineErrorText: LE.translator.translate("LEUserManagement.agentGroupEdit.errors.member.select"),
                            tagMaxWidth: "275px",
                            maxShownLines: 2,
                            tooltipAlign: "left"
                        }
                    },
                    events: {
                        select: "_onMemberSelect",
                        unselect: "_onMemberUnselect",
                        filter: "_onMemberFilter"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                }
            },
            events: {
                "mouseenter @ui.pendingAssignmentInfo": "_showPendingAssignmentBubble",
                "mouseleave @ui.pendingAssignmentInfo": "_closePendingAssignmentBubble"
            },
            modelEvents: {
                "change": "_onModelChange"
            },

            customTemplateHelpers: function() {
                var parentGroupId = this.model.getParentGroupId();
                var parentGroupName = LEUserManagement.getDataManager().getNameById(LEUserManagement.getDataManager().getEntities().AGENT_GROUP, parentGroupId);
                return {
                    parentGroupName: parentGroupName
                };
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                this.model = options.model;
                this.modelValidators = this.model.MODEL_VALIDATORS;
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_EDIT);
                this.currentMembersCollection = options.currentMembersCollection;
            },

            _onRender: function() {
                this._bindEvents();
                this._updateSaveButtonState();
                this._setFocus();
            },

            _bindEvents: function() {
                this.listenTo(this.currentMembersCollection ,"reset", this._onCollectionReset);
                this.listenTo(this.channel.vent, "agentGroup:save:success", this._onSaveSuccess);
                this.listenTo(this.channel.vent, "agentGroup:save:error", this._onSaveError);
            },

            _setFocus: function() {
                this.uiComponents.agentGroupName.setFocus(true);
            },

            _pendingAssignment: function() {
                var isNewMembers = this.model.getIsMemberChange() && _.difference(this.model.getMembers(), this.model.getPreviousMembers()).length > 0;
                this.ui.pendingAssignment.toggleClass("hide", !isNewMembers);
            },

            _updateSaveButtonState: function() {
                var isModelValid = this.model.validateSaveEnabled();

                if (!isModelValid) {
                    this.uiComponents.saveButton.setEnabled(false);
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.agentGroupEdit.saveButton.tooltip.mandatoryFields"));
                }
                else {
                    if (!this.model.isValueChanged()) {
                        this.uiComponents.saveButton.setEnabled(false);
                        this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.agentGroupEdit.saveButton.tooltip.noChanges"));
                    }
                    else {
                        this.uiComponents.saveButton.setEnabled(true);
                        this.uiComponents.saveButton.setTooltip("");
                    }
                }
            },

            _onModelChange: function() {
                this._updateSaveButtonState();
            },

            _onNameChange: function(componentId, eventName, value) {
                this.channel.trigger("agentGroup:change:name", value);
            },

            _onCancel: function() {
                this.channel.trigger("agentGroup:cancel");
            },

            _onSave: function() {
                this.channel.trigger("agentGroup:save");
            },

            _onSaveSuccess: function() {
                this._hideErrors();
            },

            _onSaveError: function(errors) {
                this._setErrors(errors);
            },

            _setErrors: function(errors) {
                this._hideErrors();

                this.errorsOnPage = errors;

                if (_.has(errors, this.model.KEYS.NAME)) {
                    this.uiComponents.agentGroupName.setError(true, errors[this.model.KEYS.NAME]);
                }

                if (_.has(errors, this.model.KEYS.DESCRIPTION)) {
                    this.uiComponents.agentGroupDescription.setError(true, errors[this.model.KEYS.DESCRIPTION]);
                }
            },

            _hideErrors: function () {
                this.errorsOnPage = null;
                this.uiComponents.agentGroupName.setError(false);
                this.uiComponents.agentGroupDescription.setError(false);
            },

            _getSelectedManagersItems: function() {
                return this._convertUserIdsToMultiselectArr(this.model.getManagers(), this.model.getManagers());
            },

            _onManagerFilter: function(componentId, eventName, options) {
                var value = options.value;
                var successCallback = options.success;

                var usersCollection = new UsersCollection([], {urlSelectParameter:UsersCollection.URL_SELECT_PARAMETER.LIST});
                usersCollection.fetch({
                    data: {
                        "startsWith": value,
                        "offset": 0,
                        "first": 2000,
                        "include_deleted": false,
                        "orderBy": "fullName",
                        "orderDirection": "asc"
                    },
                    success: _.bind(function(collection, response, options) {
                        var potentialManagerIds = this._getPotentialManagers(collection);
                        var multiselectArr = this._convertUserIdsToMultiselectArr(potentialManagerIds, this.model.getManagers());
                        successCallback(multiselectArr);
                    }, this)
                });
            },

            _getPotentialManagers: function(collection) {
                var potentialIds = [];
                collection.each(_.bind(function(userModel) {
                    var groupsUnderLoggedInUser = LEUserManagement.getDataManager().getAgentManagerDependencyModel().getGroups();
                    var userManagedGroups = _.map(userModel.getManagerOf(), "agentGroupId");

                    if ((LEUserManagement.hasEntireAgentGroupTreePrivilege() && (!LE.sessionManager.hasProfilesFeature() || this._isAgentManagerWithProfiles(userModel))) || _.intersection(groupsUnderLoggedInUser, userManagedGroups).length > 0) {
                        potentialIds.push(userModel.id);
                    }
                }, this));

                return potentialIds;
            },

            _onManagerSelect: function(componentId, eventName, managerObj) {
                this.channel.trigger("agentGroup:manager:add", managerObj.id);
            },

            _onManagerUnselect: function(componentId, eventName, managerObj) {
                this.channel.trigger("agentGroup:manager:remove", managerObj.id);
            },

            _getSelectedMembersItems: function() {
                return this._convertUserIdsToMultiselectArr(this.model.getMembers(), this.model.getMembers());
            },

            _onMemberFilter: function(componentId, eventName, options) {
                var value = options.value;
                var successCallback = options.success;

                var usersCollection = new UsersCollection([], {urlSelectParameter:UsersCollection.URL_SELECT_PARAMETER.LIST});
                usersCollection.fetch({
                    data: {
                        "startsWith": value,
                        "offset": 0,
                        "first": 2000,
                        "include_deleted": false,
                        "orderBy": "fullName",
                        "orderDirection": "asc"
                    },
                    success: _.bind(function(collection, response, options) {
                        var potentialMemberIds = this._getPotentialMembers(collection);
                        var multiselectArr = this._convertUserIdsToMultiselectArr(potentialMemberIds, this.model.getMembers());
                        successCallback(multiselectArr);
                    }, this)
                });
            },

            _getPotentialMembers: function(collection) {
                var potentialIds = [];
                collection.each(_.bind(function(userModel) {
                    var agentsUnderLoggedInUser = LEUserManagement.getDataManager().getAgentManagerDependencyModel().getAgents();

                    if ((LEUserManagement.hasEntireAgentGroupTreePrivilege() || _.include(agentsUnderLoggedInUser, userModel.id)) && (!LE.sessionManager.hasProfilesFeature() || this._isAgentWithProfiles(userModel))) {
                        if (!_.include(this.model.getMembers(), userModel.id)) {
                            potentialIds.push(userModel.id);
                        }
                    }
                }, this));

                return potentialIds;
            },

            _onMemberSelect: function(componentId, eventName, memberObj) {
                this.channel.trigger("agentGroup:member:add", memberObj.id);
                this._pendingAssignment();
            },

            _onMemberUnselect: function(componentId, eventName, memberObj) {
                this.channel.trigger("agentGroup:member:remove", memberObj.id);
                this._pendingAssignment();
            },

            _onDescriptionChange: function(componentId, eventName, value) {
                this.channel.trigger("agentGroup:description:change", value);
            },

            _onPagingChange: function(componentId, eventName, currentPageNumber) {
                this.channel.trigger("paging:change", currentPageNumber);
            },

            _showPendingAssignmentBubble: function() {
                this._closePendingAssignmentBubble(null, true);
                this.uiComponents.host$.createAndRender("pendingAssignmentBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.pendingAssignmentInfo,
                        position: Bubble.POSITION.TOP,
                        showCloseButton: false,
                        isDelayed: true,
                        text: LE.translator.translate("LEUserManagement.agentGroupEdit.members.pending.assignment.info")
                    }
                });
            },

            _closePendingAssignmentBubble: function(event, force) {
                if (this.uiComponents.pendingAssignmentBubble) {
                    this.uiComponents.pendingAssignmentBubble.close(force);
                }
            },

            _convertUsersCollectionToMultiselectArr: function(options) {
                options = options || {};
                var collection = options.collection;
                var selected = options.selected;

                var multiselectArr = [];
                collection.each(function(userModel) {
                    var subText = userModel.getLoginName();
                    if(!userModel.getEnabled()){
                        subText += " - " + LE.translator.translate("LEUserManagement.agentGroupEdit.member.disabled");
                    }

                    multiselectArr.push({
                        id: userModel.id,
                        value: userModel.getDisplayName(),
                        selected: _.include(selected, userModel.id),
                        subText: subText
                    });

                }, this);

                return multiselectArr;
            },

            _convertUserIdsToMultiselectArr: function(ids, selectedIds) {
                var usersCollection = LEUserManagement.getDataManager().getUsersCollection();
                var multiselectArr = [];
                _.each(ids, _.bind(function(id) {
                    var userModel = usersCollection.get(id);
                    if (userModel) {
                        var subText = userModel.getLoginName();
                        if(!userModel.getEnabled()){
                            subText += " - " + LE.translator.translate("LEUserManagement.agentGroupEdit.member.disabled");
                        }

                        multiselectArr.push({
                            id: userModel.id,
                            value: userModel.getDisplayName(),
                            selected: _.include(selectedIds, id),
                            subText: subText
                        });
                    }
                }, this));
                return multiselectArr;
            },

            _isAgentWithProfiles: function(userModel) {
                var isAgent;
                var profilesCollection = LEUserManagement.getDataManager().getProfilesCollection();
                if(profilesCollection) {
                    isAgent = userModel.hasRoleType(profilesCollection, profilesCollection.ROLES.AGENT);
                }
                return isAgent;
            },

            _isAgentManagerWithProfiles: function(userModel) {
                var isAgentManager;
                var profilesCollection = LEUserManagement.getDataManager().getProfilesCollection();
                if(profilesCollection) {
                    isAgentManager = userModel.hasRoleType(profilesCollection, profilesCollection.ROLES.AGENT_MANAGER);
                    if (!LE.sessionManager.hasProfilesFeature()) {
                        isAgentManager = isAgentManager || userModel.hasRoleType(profilesCollection, profilesCollection.ROLES.ADMIN);
                    }
                }
                return isAgentManager;
            },

            _onCollectionReset: function() {
                // set correct paging
                var pagingInfo = this.currentMembersCollection.getPagerInfo();
                this.uiComponents.paging.setInfo(pagingInfo.currentPageNumber, pagingInfo.totalPages);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupEditView;

});
